// 在现有的翻译对象中添加
export default {
  header: {
    kuaiche: '快车科技',
    ai: 'AI赋能',
    clusterAgent: '产业集群智能体',
    divine: 'AI 六脉神剑',
    tianlongbabu: 'AI 天龙八部',
    corporate: '公司价值',
    qualification: '资质荣誉',
    hire: '寻找超人'
  },
  home: {
    slideTxt1: '为城市数字经济产业建链、建平台',
    slideTxt2: '为平台链主赋能AI数字化、智能化',
    exhibitionHallTitle1: '城市客厅+数字经济平台',
    exhibitionHallTitle2: 'City Exhibition Hall + Digital Economy Platform',
    topBrandTitle1: '中山城市100强链主',  
    topBrandTitle2: 'The Top 100 Enterprises in Zhongshan City',  
    numbers: {
      cityLivingRoom: '城市客厅',
      centralEnterprises: '合作"链主"央企',
      domesticIP: '合作"链主"企业国内IP',
      internationalIP: '合作"链主"企业国际IP',
      onlinePlatform: '线上平台',
      scenicSpots: '合作"链主"风景名胜区',
      walkingStreets: '合作"链主"著名步行街',
      hotels: '合作"链主"酒店文宿'
    } 
  },
  footer: {
    address: '地址',
    addressDetail: '中山市博爱六路 综合展厅城市客厅2号门',
    publicAccount: '公众号',
  },
  digitalPlatform: {
    homeTitle1: '数字城市：链接、赋能：链主',
    homeTitle2: 'Digital City: Linkage, Empowerment: Chain Leader'
  },
  aboutUs: {
    introTitle: '快车科技简介',
    businessTitle: '快车科技主营业务',
    cityTitle: '以城市之名 迎八方来客',
    cityPreTitle: '政府/超级IP/合作伙伴/超级买家，每年来访300+',
    msgTitle: '快车科技利好消息',
    goDetails: '查看详情',
    highlights: {
      item1: '中山市工业产品线上展销平台发布',
      item2: '国际城市客厅战略合作签约',
      item3: '“灵枢”成功通过国家网信办人工智能服务备案',
      item4: '快车自研三款AI应用系统成功入选省第一批制造业赋能资源遴选通过名单',
      item5: '文旅战略合作签约',
      item6: 'Pre-IPO投资意向签约',
      item7: 'AI 快车科技成果技术评定：中国领先',
      item8: '全球战略合作签约',
      item9: '低空智慧城市客厅合作签约',
    },
  },
  digitalEmpowerment: {},
  cityLivingroom: {
    title: '城市客厅',
    livingRooms: {
      zhongshan: '大湾区中山城市客厅',
      quanzhou: '福建泉州城市客厅',
      nanyue: '湖南南岳城市客厅',
      haizhu: '广州海珠低空大模型城市客厅',
      yantian: '深圳盐田低空城市客厅',
      lishui: '浙江丽水城市客厅',
      harbin: '哈尔滨城市客厅',
      macau: '澳门城市客厅',
      malaysia: '马来西亚城市客厅',
      thailand: '泰国城市客厅'
    }
  },
  innovativeProduct: {
    ipTitle: 'IP联名+城市文创+工业文创+自主创新',
    productDesc: '自研城市大脑、数字城市终端产品',
  },
  integratedSolution: {
    title: '综合解决方案',
    solutions: {
      zhongshan: '中山市数字经济产业平台+中山城市客厅综合解决方案',
      yantian: '全球最大港口，盐田低空城市客厅+低空全球选品出口平台',
      quanzhou: '泉州市数字经济产业平台+泉州城市客厅综合解决方案',
      harbin: '哈尔滨数字经济产业平台+哈尔滨城市客厅综合解决方案',
      lishui: '丽水数字经济产业平台+丽水城市客厅综合解决方案'
    }
  },
  hire: {
    applyNow: '立即申请',
    tabs: {
      rules: '规章制度',
      positions: '公司架构'
    },
    allJobs: '招聘岗位',
    noPositions: '暂无招聘岗位',
    groups: {
      operation: '产业智能体运营中心',
      efficiency: '数智组织效能中心',
      business: '数智市场商务拓展中心',
      technology: '产业智能体技术工程中心',
      governance: '治理层与城市合伙人',
      other: '其他岗位'
    },
    cardTags: {
      recruitment: '招聘JD',
      responsibilities: '岗位职责',
      content: '工作内容'
    },
    columns: {
      codes: '编号',
      position: '招聘岗位',
      under: '所属中心',
      location: '地区',
      openings: '岗位数',
      details: '岗位详情'
    },
    applyDialogTitle: '投递简历',
    applyDialogTip: '请将您的简历发送至以下邮箱：',
    applyDialogCopy: '复制',
    applyDialogCopied: '邮箱已复制',
    location: '位置',
    companyIntro: '快车科技简介',
    companyIntroContent1: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;AI快车科技，成立于 2008 年 8 月 8 日，2023年被评为北交所成长Top20强创新层三板企业，股票代码：872498，<strong>目前是国家级专精特新 “小巨人” 企业</strong>，也是国务院“共链行动” AI 平台企业。深耕城市级产业数字化领域长达 17 年，成为了全球AI应用领军企业，<strong>用AI提升链主增量、城市增量，构建数字产业链</strong>。',
    companyIntroContent2: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;链主企业客户对于怎样增加销量、增加买家好感非常关注，AI快车科技用例如：数字人、元宇宙、AI销售矩阵、AI客服、数字资产等技术实现企业的销售增量、增加业绩，增加买家信任度！',
    companyIntroContent3: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在“城市客厅+城市产业数字平台”双循环模式中，是创新模式的开创者、是行业标准的制定者、是AI应用行业的引领者，目前该模式得到国内乃至国外多个城市管理者的高度认可并达成合作意向，企业愿景希望用AI赋能100+城市、1000+行业、10000+链主企业，让更多城市和产业AI在线，让中国技术力量贡献世界！',
    title: '招聘岗位',
    readBeforeApply: '应聘前必读',
    newsItems: {
      news1: '数字城市客厅全球化战略【国家小巨人：AI快车科技】',
      news2: '快车科技启动纳斯达克上市计划 以“城市客厅”模式赋能全球数字经济',
      news3: '深入实施“人工智能行动+”行动，景区实践落地篇',
      news4: 'AI这样赋能城市数字经济发展真香！蓝海赛道：City 2 City',
      news5: '工业AI落地产业集群，AI快车科技冲刺港股18C'
    }
  }
}
